module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-9-e2577a10c48cc9a14b3ff8d85431961c.svg";